// Facturacion.js
import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'
import Card from 'react-bootstrap/Card'
import Alert from 'react-bootstrap/Alert'
import './Facturacion.css'

function Facturacion(props) {
	const { datos } = props

	if (!datos) {
		return (
			<Alert variant="info">No hay datos de facturación disponibles</Alert>
		)
	}

	// Determinar el estado de formalización
	const tieneDatosFiscales = datos.razonSocial && datos.ruc

	return (
		<Container fluid className="facturacion-container">
			<Row>
				<Col>
					<Card className="mb-4">
						<Card.Header>
							<h5 className="mb-0">Estado de formalización</h5>
						</Card.Header>
						<Card.Body>
							<div className="estado-formalizacion">
								{tieneDatosFiscales ? (
									<>
										<Badge bg="success" className="me-2">Formalizado</Badge>
										<span>El profesional cuenta con datos fiscales completos</span>
									</>
								) : (
									<>
										<Badge bg="warning" text="dark" className="me-2">Pendiente</Badge>
										<span>El profesional aún no ha completado sus datos fiscales</span>
									</>
								)}
							</div>
						</Card.Body>
					</Card>

					<Card>
						<Card.Header>
							<h5 className="mb-0">Datos fiscales</h5>
						</Card.Header>
						<Card.Body>
							<Table striped bordered hover responsive>
								<tbody>
									<tr>
										<th>Razón Social</th>
										<td>{datos.razonSocial || <span className="text-muted">No especificado</span>}</td>
									</tr>
									<tr>
										<th>RUC</th>
										<td>{datos.ruc || <span className="text-muted">No especificado</span>}</td>
									</tr>
								</tbody>
							</Table>

							{!tieneDatosFiscales && (
								<Alert variant="info" className="mt-3">
									<i className="fa fa-info-circle me-2"></i>
									Los profesionales pueden realizar su primer servicio sin datos fiscales completos,
									pero deben formalizarse para continuar prestando servicios en la plataforma.
								</Alert>
							)}
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	)
}

export default Facturacion